'use client';

import Link from 'next/link';

import { IconDynamic } from '@/components/ui';

import { type NavItemType } from '../../utils';

export const NavItem = ({ href, icon, label, onClick }: NavItemType) => {
  return (
    <Link
      onClick={onClick}
      href={href ? href : {}}
      className="flex items-center justify-center flex-1 py-2 not-last:border-r not-last:border-r-foreground/10 flex-col gap-1 text-foreground"
    >
      {IconDynamic(icon, { width: 20, height: 20, fill: 'currentColor' })}
      <span className="text-xs font-semibold uppercase text-center">{label}</span>
    </Link>
  );
};
